<template id="page">
  <div >
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{$t("main_title")}}
    </h1>
    <div class="main_wrap">
      <div v-if="$props.main.isLoad === false">
        <svg class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </div>
      <div v-if="$props.main.isLoad === true">
      <div class="mobiSection" v-for="hot in $props.main.category" :key="hot.key">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <img class="mobiIcon" :src="HotPickIcon_cutehub" alt="" />
            <span class="text_color">{{ $t("hotpicks") }} - 
              <span v-if="lang_cutehub !== 'english'">{{ hot[`title_${lang_cutehub}`] }}</span>
              <span v-if="lang_cutehub === 'english'">{{ hot.category }}</span>
            </span>
          </h2>
          <div class=" link right">
            <router-link :to="{path: 'hotpicks', query: { q: hot.category } }" class="browse_link">{{$t("view_more")}} ></router-link>
          </div>
        </div>
        <div class="mobiSection__content">
          <div class="row">
            <div v-for="data in getAllData()[hot.category]" :key="data.key" :class="getAllData()[hot.category]['class']">
              <div v-if="data.parent_category === hot.category" >
                <div v-if="hot.category !== 'Video'">
                  <router-link class="mobiApp" :to="{name: 'DetailPage', params: { id: data.id } }" >
                    <div v-if="data.content_type === 'application/x-zip-compressed' && data.parent_category === 'Game'" class="mobibadge badge--html5">
                      <img src="../../assets/cutehub/imgs/html5-badge.png"/>
                    </div>
                    <div class="mobiApp__thumb">
                      <img class="img_wrp" :src="data.thumbnail_url" alt="" />
                    </div>
                    <div class="mobiApp__info">
                        <!-- <h3 class="mobiTitle sm text_color">{{ data.content_name }}</h3> -->
                        <span v-if="lang_cutehub !== 'english'">
                          <h3 class="mobiTitle sm text_color" v-if="data[`cont_name_${lang_cutehub}`] !== ''">{{ data[`cont_name_${lang_cutehub}`] }}</h3>
                          <h3 class="mobiTitle sm text_color" v-else>{{ data[`cont_name_english`] }}</h3>
                        </span>
                        <span v-else>
                          <h3 class="mobiTitle sm text_color">{{ data[`cont_name_english`] }}</h3>
                        </span>
                      <div>
                        <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                        <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#feb801" inactive-color="transparent" active-color="#ffb902" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                        :rating="Number(data.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div v-else>
                  <router-link class="browse_link mobiVideo mobiVideo--mrgn" :to="{name: 'DetailPage', params: { id: data.id } }" >
                    <div class="mobiVideo__thumb">
                      <img class="img_wrp" :src="data.thumbnail_url" alt="" />
                    </div>
                      <div class="playBtn"><span></span></div>
                    <div class="mobiVideo__info">
                        <!-- <h3 class="mobiTitle sm">{{ data.content_name }}</h3> -->
                        <span v-if="lang_cutehub !== 'english'">
                          <h3 class="mobiTitle sm" v-if="data[`cont_name_${lang_cutehub}`] !== ''">{{ data[`cont_name_${lang_cutehub}`] }}</h3>
                          <h3 class="mobiTitle sm" v-else>{{ data[`cont_name_english`] }}</h3>
                        </span>
                        <span v-else>
                          <h3 class="mobiTitle sm">{{ data[`cont_name_english`] }}</h3>
                        </span>
                      <div>
                          <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                          <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#feb801" inactive-color="transparent" active-color="#ffb902" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                          :rating="Number(data.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
export default {
  data() {
    return {};
  },
  components:{
    StarRating
  },
  props: ["main"],
  computed: mapGetters([
    "HotPickIcon_cutehub",
    "PopularIcon_cutehub",
    "lang_cutehub",
    "country_cutehub"
  ]),
  created() {
  },
  methods: {
    getAllData() {
      let data = this.$props.main.hotpicks;
      let dat = Object.keys(data);
      dat.map(item => {
        if (item == "Video") {
          data[item].class = "col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem";
        } else {
          data[item].class = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        }
      });
      return data;
    }
  }
};
</script>

<style scoped>
.main_title {
  color: black;
}

.browse_link {
  color: black;
}

/* .img_wrp {
  width: 200px;
  height: 200px;
} */
</style>



// WEBPACK FOOTER //
// src/components/cutehub/Main.vue